import GlobalIncomExpense from './GlobalIncomExpense'
export default GlobalIncomExpense
